import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { GeneralResponse } from "../../../types/api";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { IForgetPasswordResetPasswordRequest } from "../../../types/apis/auth-apis";

export const ForgetPasswordResetPassword = async (
  payload: IForgetPasswordResetPasswordRequest,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<
      any,
      GeneralResponse<IForgetPasswordResetPasswordRequest>
    >({
      method: Methods.POST,
      endpoint: EndPoints.profileForgetPasswordResetPassword,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useProfileForgetPasswordResetPassword = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: IForgetPasswordResetPasswordRequest }
  > = useMutation({
    mutationFn: ({ payload }) => ForgetPasswordResetPassword(payload),
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
